import React, { Component } from 'react';
import PropTypes from 'prop-types';
import anime from 'animejs';
import OwlCarousel from 'react-owl-carousel';

const LeftNavButton = ({}) => (
  <button {...this.props}>Next</button>
);

class Title extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      index: null,
    }
    this.changeTitle = this.changeTitle.bind(this);
  }
  
  changeTitle(data, index) {
    anime.remove('.slider_title');
    anime({
      targets: '.slider_title',
      translateY: 0,
      opacity: 1,
      duration: 1000
    });
    if (!!data && index !== null && index >= 0 && this.state.index !== index) {
        this.setState({
          title: data[index].title,
          index: index
        });
    }
  }

  render() {
    return (
      <div className="slider_title">
        <span className="slider_title_wrap">{this.state.title}</span>
        <span className="info" onClick={(e) => {
          this.props.openData(this.state.index);
        }}><i className="fas fa-info-circle"></i></span>
      </div>
    )
  }
}

class Dots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0
    }
    this.changeDot = this.changeDot.bind(this);
  }
  
  changeDot(data, index) {
    if (!!data && index !== null && index >= 0 && this.state.index !== index) {
        this.setState({
          index: index
        });
    }
  }

  render() {
    return (
      <div id="dots-container" className="dots-container">
        {this.props.data.map((item, i) => {
          return (
            <span key={i} onClick={(e) => {
              e.preventDefault();
              this.props.onGoTo(i);
            }} className={`${this.state.index === i ? 'active' : ''}`}>
              <i className="fas fa-paint-brush"></i>
            </span>
          )
        })}
      </div>
    )
  }
}

export default class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curPos: null,
      title: ''
    };
    this.goTo = this.goTo.bind(this);
  }

  goTo(index) {
    if (index => 0 && this._slider) {
      this._slider.to(index, 700);
    }
  }

  render() {
    const that = this;
    const settings = {
      className: 'owl-theme',
      margin: 0,
      items: 1,
      loop: false,
      nav: false,
      center: true,
      dots: false,
      autoplay: true,
      autoplayHoverPause: true,
      onChanged: (slide, i) => {
        anime({
          targets: '.slider_title',
          translateY: -50,
          opacity: 0,
          duration: 0
        });
        setTimeout(() => {
          this._title.changeTitle(this.props.data, slide.item.index);
          this._dots.changeDot(this.props.data, slide.item.index);
        }, 1)
      }
    };
    
    return (
      <div style={{ height: '100%', minHeight: '100%' }}>
        <div className="alternative-borders">
          <div className="border-t-line"></div>
          <div className="border-b-line"></div>
          <div className="border-r-line"></div>
          <div className="border-l-line"></div>
        </div>
        <div className="curtains">
          <div className="curtains-t"></div>
          <div id="curtain-l" className="curtains-l"></div>
          <div id="curtain-r" className="curtains-r"></div>
          <div id="curtain-b" className="curtains-b"></div>
        </div>
        <OwlCarousel { ...settings } ref={inst => this._slider = inst}>
          {this.props.data.map((item,i) => {
            return (
              <div key={i} className="slide" style={{ backgroundImage: `url(${item.url})`}}>
                
              </div>
            )
          })}
        </OwlCarousel>

        <div className="slider-navigation">
          <button className="prev" onClick={() => this._slider.prev()}><i className="fas fa-chevron-left"></i></button>
          <button className="next" onClick={() => this._slider.next()}><i className="fas fa-chevron-right"></i></button>
        </div>

        <div id="slider-data" className="slider_data">
          <Title openData={(index) => {
            if (this.props.data[index]) {
              this.props.openData(this.props.data[index]);
            }
          }} ref={(el) => this._title = el } />
          <Dots onGoTo={this.goTo} data={this.props.data} ref={(el) => this._dots = el } />
        </div>
      </div>
    )
  }
}
Slider.defaultProps = {
  data: []
}

Slider.propTypes = {}


// WEBPACK FOOTER //
// ./src/components/Slider.js